<template>
  <f7-page id="account-verify-email" name="account-verify-email" @page:afterin="afterin">
    <div class="block">
      <div class="wandr-title-1 ac mb-md">{{ $t('ua-verification-sent') }}</div>
      <p class="ac mt-md">{{ $t('ua-email-verification-detail') }}</p>

      <div class="text-align-center mt-xl">
        <img class="" :src="require('@/assets/img/icon/icon-email-success.svg')" style="" />
      </div>

      <f7-button round large fill @click="goToNextPage" class="mt-5 view-desktop" :disabled="false">
        {{ $t('label-common-ok') }}
      </f7-button>      
    </div>

    <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
      <f7-button large fill @click="goToNextPage" :disabled="false">
          {{$t('label-common-ok')}}
      </f7-button>
    </f7-toolbar>
  </f7-page>
</template>

<style>
#account-verify-email .wandr-title-1 {
  color: #252525;
}
/*
#account-verify-email img.email-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
*/
#account-verify-email p {
  color: var(--f7-color-gray);
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
}
/*
#account-verify-email .footer{
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
}
*/
</style>

<script>
  export default {    
    mounted (){
      
    },
    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      goToNextPage() {
        //this.$f7router.navigate("/account/my-details", { props: { isFromUpdateEmail: true }, ignoreCache : true, clearPreviousHistory  : true });

        this.$f7router.navigate("/home", {ignoreCache : true, clearPreviousHistory  : true });
      },
    },
    components: {
      
    },
    computed: {
      
    },
  }
</script>